/* global axios */
import ApiClient from './ApiClient';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

// Informes › Métricas Avanzadas / Rendimiento Digital (Victor 2026-05-23).
// Endpoints de SOLO LECTURA.
class AdvancedMetricsAPI extends ApiClient {
  constructor() {
    super('advanced_metrics', { accountScoped: true, apiVersion: 'v2' });
  }

  executive(params = {}) {
    return axios.get(`${this.url}/executive`, {
      params: { ...params, timezone_offset: getTimeOffset() },
    });
  }

  team(params = {}) {
    return axios.get(`${this.url}/team`, { params });
  }

  // Eficiencia del Equipo · Inicio de sesión por sucursal (Victor 2026-06-09).
  teamLogin(params = {}) {
    return axios.get(`${this.url}/team_login`, { params });
  }

  platforms(params = {}) {
    return axios.get(`${this.url}/platforms`, { params });
  }

  realtime(params = {}) {
    return axios.get(`${this.url}/realtime`, { params });
  }

  liveClients(params = {}) {
    return axios.get(`${this.url}/live_clients`, { params });
  }

  // Expediente de un agente: a quién atiende ahora + conversaciones respondidas.
  agentDetail(params = {}) {
    return axios.get(`${this.url}/agent_detail`, { params });
  }

  // Espejo en vivo: últimos mensajes de una conversación.
  conversationMessages(params = {}) {
    return axios.get(`${this.url}/conversation_messages`, { params });
  }
}

export default new AdvancedMetricsAPI();
